import { Link } from "react-router-dom";
import { Instagram, Mail, Star } from "lucide-react";
import { toast } from "sonner";
import { LINKS } from "@/data";

const Footer = () => (
  <footer className="border-t border-white/10 bg-ink px-6 py-16 text-paper md:px-12" data-testid="site-footer">
    <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="font-display text-3xl font-black uppercase tracking-tight md:text-4xl">
          Kin Hakan<br />Azriel Gobel
        </p>
        <p className="mt-3 font-serif text-lg italic text-paper/60">Creator. Communicator. Changemaker.</p>
      </div>
      <div className="flex flex-col gap-3 font-display text-xs uppercase tracking-[0.25em]">
        <a href={LINKS.instagram} target="_blank" rel="noreferrer" className="u-link flex w-fit items-center gap-2 text-paper/80 hover:text-ember" data-testid="footer-instagram-link" data-cursor="VISIT">
          <Instagram className="h-4 w-4" /> @kinhakann
        </a>
        <a href={`mailto:${LINKS.email}`} className="u-link flex w-fit items-center gap-2 text-paper/80 hover:text-ember" data-testid="footer-email-link" data-cursor="SAY HI">
          <Mail className="h-4 w-4" /> {LINKS.email}
        </a>
        <Link to="/journal" className="u-link w-fit text-paper/80 hover:text-ember" data-testid="footer-journal-link">Journal / Stories</Link>
      </div>
    </div>
    <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 font-display text-[10px] uppercase tracking-[0.3em] text-paper/40 md:flex-row md:items-center">
      <span>© 2026 Kin Hakan Azriel Gobel</span>
      <button
        data-testid="footer-hidden-note"
        onClick={() => toast("Still exploring. Still creating. Still becoming.", { description: "— thanks for scrolling all the way down here." })}
        className="group flex items-center gap-2 hover:text-ember"
        data-cursor="?"
      >
        <Star className="h-3 w-3 transition-transform duration-500 group-hover:rotate-180" />
        still becoming
      </button>
      <span>A record of becoming</span>
    </div>
  </footer>
);

export default Footer;
